import { render, staticRenderFns } from "./ShareSponsorQuizBox.vue?vue&type=template&id=1c41dbaa&"
import script from "./ShareSponsorQuizBox.vue?vue&type=script&lang=js&"
export * from "./ShareSponsorQuizBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports